(function ($) {
    $(document).ready(function () {

        // Rate System
        if (typeof API_BASE_URL == 'undefined') {
            API_BASE_URL = "";
        }

        $('.recipe-detail__rate-btn').each(function () {
            const recipeDetail = $('.recipe-detail__header-content');
            const $container = $(this);
            const recipeId = $container.data('recipe-id');
            const $toggleBtn = $container.find('.js-recipe-detail-rate');
            const $box = $container.find('.recipe-detail__rate-btn-rating-box');
            const $stars = $container.find('.rating');
            const $submit = $container.find('.recipe-detail__rate-submit');

            let selectedRating = 0;
            let averageRating = 0;
            let ratingCount = 0;

            // ----------------------------
            // Fetch user rating & average dynamically
            // ----------------------------
            $.ajax({
                url: `${API_BASE_URL}/api/rating/recipestatus?recipeId=${recipeId}`,
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    if (!response) return;

                    const rawAverage = response.AvarageRating || 0;

                    const dataRating = Number.isInteger(rawAverage)
                        ? rawAverage
                        : Math.round(rawAverage / 0.5) * 0.5;

                    averageRating = Number.isInteger(rawAverage)
                        ? rawAverage
                        : Math.round(rawAverage * 10) / 10;

                    ratingCount = response.RatingCount || 0;

                    const userRating = response.UserRating || 0;

                    // Update rating data (important for star rendering)
                    recipeDetail.find('.total-ratings').attr('data-rating', dataRating);

                    // Update user rating data (important for star rendering)
                    recipeDetail.find('.js-recipe-detail-rate-btn-ratings').attr('data-user-rating', dataRating);

                    // Update average
                    recipeDetail.find('.js-average-rating').text(`${averageRating} / 5`);

                    // Restore user rating
                    if (userRating > 0) {
                        selectedRating = userRating;

                        $stars.each(function () {
                            const starVal = Number($(this).attr('class').match(/rating-(\d)/)[1]);
                            $(this).toggleClass('is-filled', starVal <= userRating);
                        });

                        $submit.prop('disabled', false);
                    }
                },
                error: function () {
                    console.warn('Could not fetch rating status for recipe', recipeId);
                }
            });


            // ----------------------------
            // Submit rating
            // ----------------------------
            $submit.on('click', function () {
                if (!selectedRating) return;

                // Get the current user rating from the data attribute
                const currentUserRating = Number(
                    recipeDetail
                        .find('.js-recipe-detail-rate-btn-ratings')
                        .attr('data-user-rating') || 0
                );

                // If user selects the same rating, do nothing
                if (selectedRating === currentUserRating) {
                    return;
                }

                $.ajax({
                    url: `${API_BASE_URL}/api/rating/recipe?recipeId=${recipeId}&userRating=${selectedRating}`,
                    type: 'GET',
                    dataType: 'json',
                    success: function (response) {
                        if (!response) return;

                        const rawAverage = response.AvarageRating;

                        const dataRating = Number.isInteger(rawAverage)
                            ? rawAverage
                            : Math.round(rawAverage / 0.5) * 0.5;

                        averageRating = Number.isInteger(rawAverage)
                            ? rawAverage
                            : Math.round(rawAverage * 10) / 10;

                        ratingCount = response.RatingCount;

                        // Update UI: average and star data
                        recipeDetail.find('.total-ratings').attr('data-rating', dataRating);

                        recipeDetail.find('.js-recipe-detail-rate-btn-ratings').attr('data-user-rating', selectedRating); // update to new rating

                        recipeDetail.find('.js-average-rating').text(`${averageRating}/5`);

                        $submit.remove(); // hide submit button

                        $stars.css('pointer-events', 'none'); // disable all stars from clicking

                        // Show success message
                        const $successMsg = recipeDetail.find('.recipe-detail__rate-btn-success-msg');

                        $successMsg.removeAttr('hidden'); 

                        // Optionally hide the "Rate" toggle button
                        recipeDetail.find('.js-recipe-detail-rate').hide();
                    },
                    error: function () {
                        alert('Rating failed. Please try again.');
                    }
                });
            });

            // ----------------------------
            // Toggle rate box
            // ----------------------------
            $toggleBtn.on('click', function () {
                const isOpen = $box.hasClass('active');

                $(this).text(isOpen ? 'Rate' : 'Close');

                $box.toggleClass('active');
            });

            // ----------------------------
            // Select rating
            // ----------------------------
            $stars.on('click', function () {
                const rating = Number($(this).attr('class').match(/rating-(\d)/)[1]);

                selectedRating = rating;

                $stars.removeClass('is-filled');

                $stars.each(function () {
                    const current = Number($(this).attr('class').match(/rating-(\d)/)[1]);
                    if (current <= selectedRating) $(this).addClass('is-filled');
                });

                $submit.prop('disabled', false);
            });
        });

        // Share Dropdown Logic
        $('.js-recipe-detail-cta-share').on('click', function (e) {
            e.stopPropagation();

            $(this).toggleClass('is-open');
        });
    });
})(jQuery);